<div class="tooltip" [ngClass]="['tooltip--'+position]" [style.left]="left + 'px'" [style.top]="top + 'px'">
<span *ngIf="tooltip">{{(tooltip | customTranslation: translationData) ? (tooltip | customTranslation: translationData) :tooltip}}</span>
    <span *ngIf="childTemplate">
        <ng-container [ngTemplateOutlet]="childTemplate"></ng-container>
    </span>
</div>